import React from "react";
import { ChevronRight } from "lucide-react";

const COMPOSITE =
  "https://customer-assets.emergentagent.com/job_tower-crane-pro/artifacts/jftxjw7c_image.png";

// background-size: 500% 420% — shows image + yellow title banner, crops before the %
const MODULES = [
  { n: "01", title: "Introdução e Fundamentos da Operação de Grua", pos: "0% 0%" },
  { n: "02", title: "Comunicação Operacional e Trabalho em Equipa", pos: "25% 0%" },
  { n: "03", title: "Conhecimento Técnico da Grua de Comando", pos: "50% 0%" },
  { n: "04", title: "Movimentos, Comandos e Controle da Grua", pos: "75% 0%" },
  { n: "05", title: "Prática de Canteiro: Garfo, Correntes e Taipais", pos: "100% 0%" },
  { n: "06", title: "Situações Reais e Desafios da Operação", pos: "0% 43.75%" },
  { n: "07", title: "Certificado e Cartão de Manobrador", pos: "25% 43.75%" },
];

export default function Modules() {
  // Duplicate items for seamless infinite loop
  const loop = [...MODULES, ...MODULES];

  return (
    <section
      id="modulos"
      className="relative py-24 sm:py-32 bg-zinc-950 border-b border-white/10 overflow-hidden"
      data-testid="modules-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-14">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">
              O Que Vais Aprender
            </div>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
              7 MÓDULOS. <br />
              <span className="text-yellow-400">DO ZERO</span> <br />
              AO COMANDO.
            </h2>
          </div>
          <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-zinc-500">
            <ChevronRight className="w-4 h-4" />
            Auto-play · pausa ao passar o rato
            <ChevronRight className="w-4 h-4" />
          </div>
        </div>
      </div>

      {/* Auto-play carousel */}
      <div className="group relative">
        {/* Fade edges */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute top-0 bottom-0 left-0 w-24 z-10 bg-gradient-to-r from-zinc-950 to-transparent"
        />
        <div
          aria-hidden="true"
          className="pointer-events-none absolute top-0 bottom-0 right-0 w-24 z-10 bg-gradient-to-l from-zinc-950 to-transparent"
        />

        <div className="flex w-max animate-[modules-scroll_40s_linear_infinite] group-hover:[animation-play-state:paused] gap-5 px-5">
          {loop.map((m, i) => (
            <article
              key={`${m.n}-${i}`}
              data-testid={`module-card-${m.n}-${i < MODULES.length ? 'a' : 'b'}`}
              className="w-[280px] sm:w-[320px] flex-shrink-0 border border-white/10 overflow-hidden hover:border-yellow-400/60 transition-colors relative group/card"
            >
              <div
                aria-hidden="true"
                className="w-full aspect-[4/3] bg-no-repeat transition-transform duration-500 group-hover/card:scale-105"
                style={{
                  backgroundImage: `url(${COMPOSITE})`,
                  backgroundSize: "500% 420%",
                  backgroundPosition: m.pos,
                }}
              />
            </article>
          ))}
        </div>

        <style>{`
          @keyframes modules-scroll {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>
    </section>
  );
}
